import type { TextProps } from "@octopusdeploy/design-system-components";
import { TextWithLabel as Text, DebouncedTextWithLabel as DebounceText } from "@octopusdeploy/design-system-octopus-components";
import type { GlobalConnectedProps } from "~/components/form/VariableLookup/VariableLookup";
import { withVariableLookup } from "~/components/form/VariableLookup/VariableLookup";
const DebounceTextWithInputRef = (props: TextProps & GlobalConnectedProps) => <DebounceText {...props}/>;
export const VariableLookupText = withVariableLookup()(DebounceTextWithInputRef);
const TextWithInputRef = (props: TextProps & GlobalConnectedProps) => <Text {...props}/>;
export const VariableLookupTextNoDebounce = withVariableLookup()(TextWithInputRef);
